import { all, takeLatest } from "redux-saga/effects";
import { authSignIn, authSignout, authVerifySignIn, changeHospital } from "./authSaga";
import action from "../commons/loginActionStatus";
import patientActions from "../commons/patientActionStatus";
import templateActions from "../commons/templateActionStatus";
import { createTemplate, getAllTemplates } from "./templateSaga";
import prescriptionActions from "../commons/prescriptionActionsStatus";
import consultationActions from "../commons/consultationActionStatus";
import constantActionStatus from "../commons/constantActionStatus";
import { createConstant, getHistoryConfigs } from "./constantSaga";
import {
  createConsultation,
  createUpdatePhysicalData,
  getNextConsultationTextSchedule,
  getRecommendedAdditionalTests,
  getRecommendedFollowUpTests,
  getTreatmentList,
  updateConsultation,
} from "./consultationSaga";
import { getQueueData, getSilentlyQueueData } from "./queueSaga";
import queueActions from "../commons/queueActionStatus";
import { getDoctorSlotsData, getDoctorSlotsDayWiseData, getDoctorSlotsSilentlyData } from "./slotSaga";
import slotActions from "../commons/slotActionStatus";
import { createAppointment } from "./appointmentSaga";
import appointmentActions from "../commons/appointmentActionStatus";
import {
  createPatientHistoryDetails,
  createVitals,
  getPatientConsultations,
  getPatientDetails,
  getPatientHistoryDetails,
  getPatientLeapScore,
  getPatientTests,
  getPatientVitals,
  getPatientVitalsRange,
  submitPatientTestsResponse,
  updatePatientHistoryDetails,
  getLifestyleCharts,
  getRecommendedDietPlan,
  getRecommendedLifestyle,
  createOrUpdateRecommendedLifestyle,
  getEmotionCharts,
  getPhysicalFitness,
  getWeightGainCharts,
  getVisitsCharts,
  getPatientRisks,
  getPatientComplaints,
  createPatientComplaint,
  createPatientRisk,
  updatePatientComplaint,
  updatePatientRisk,
  updatePatientDetails,
  addPatientWeightGain,
  getPrescriptionChart,
  getDFMRChart,
  getEmotionData,
  postConditionData,
  getComplaintWithConditionData,
  getPatientRiskAsses,
  getPatientTimeline,
} from "./patientSaga";
import {
  createPrescription,
  getPatientSavedPrescription,
  getRecommendedPrescription,
} from "./prescriptionSaga";
import {
  createUpdateTreatmentDetails,
  endConsultation,
  getTreatmentDetails,
} from "./consultationSaga";
import { getComplaintList, getRiskList } from "./hospitalSaga";
import hospitalAction from "../commons/hospitalActionStatus";
import providerAction from "../commons/providerActionStatus";
import { getProviderDetails, updateProviderDetails } from "./providerSaga";
import scheduleAction from "../commons/scheduleActionStatus";
import { blockDaySlot, cancelBulkAppointment, createDoctorScheduleEvents, deleteScheduleEvent, deleteUnavailabilityData, getAvailabilityData, getDoctorScheduleEvents, getDoctorSlotSummary, getDoctorTimeline, getUnavailabilityData, moveBulkAppointments, postAvailabilityData, postUnavailabilityData, unblockDaySlot, updateAvailabilityData, updateScheduleEvent, updateSlotData } from "./scheduleSaga";

export default function* rootSaga() {
  return yield all([
    // ------ Sign in ------
    takeLatest(action.SIGNIN_REQUEST, authSignIn),
    // ------ verify sign in ----
    takeLatest(action.VERIFY_SIGNIN_REQUEST, authVerifySignIn),
    // ------ change hospital ----
    takeLatest(action.CHANGE_HOSPITAL_REQUEST, changeHospital),

    // ------ get patient details ---
    takeLatest(patientActions.GET_PATIENT_DETAILS_REQUEST, getPatientDetails),

    // ------ get patient vitals ---
    takeLatest(patientActions.GET_PATIENT_VITALS_REQUEST, getPatientVitals),

    //------ get patient consultation --
    takeLatest(
      patientActions.GET_PATIENT_CONSULTATION_REQUEST,
      getPatientConsultations
    ),

    // ------ get patient vitals ---
    takeLatest(
      patientActions.GET_PATIENT_VITALS_RANGE_REQUEST,
      getPatientVitalsRange
    ),

    // ------ get all templates ---
    takeLatest(templateActions.GET_ALL_TEMPLATES_REQUEST, getAllTemplates),

    // ------ get recommended prescription  ---
    takeLatest(
      prescriptionActions.GET_RECOMMENDED_PRESCRIPTION_REQUEST,
      getRecommendedPrescription
    ),

    // ------ create template ---
    takeLatest(templateActions.CREATE_TEMPLATE_REQUEST, createTemplate),

    // ------ get next consultation test of patient ---
    takeLatest(
      consultationActions.GET_NEXT_CONSULTATION_SCHEDULE_REQUEST,
      getNextConsultationTextSchedule
    ),

    // ------ get recommended additional tests ---
    takeLatest(
      consultationActions.GET_ADDITIONAL_RECOMMENDED_TEST_REQUEST,
      getRecommendedAdditionalTests
    ),

    // ------ get recommended follow up tests ---
    takeLatest(
      consultationActions.GET_FOLLOW_UP_TEST_REQUEST,
      getRecommendedFollowUpTests
    ),

    // ------ get treatment list  ---
    takeLatest(
      consultationActions.GET_CONSULTATION_OBSERVATION_REQUEST,
      getTreatmentList
    ),

    // ------ get History config ---
    takeLatest(
      constantActionStatus.GET_HISTORY_CONSTANTS_REQUEST,
      getHistoryConfigs
    ),

    // ------ get patient Leap Score data ---
    takeLatest(
      patientActions.GET_PATIENT_LEAP_SCORE_REQUEST,
      getPatientLeapScore
    ),

    // ------ get patient History data ---
    takeLatest(
      patientActions.GET_PATIENT_HISTORY_REQUEST,
      getPatientHistoryDetails
    ),
    // ------ get queue data  ---
    takeLatest(queueActions.GET_QUEUE_REQUEST, getQueueData),
    takeLatest(queueActions.GET_SILENT_QUEUE_REQUEST, getSilentlyQueueData),

    // ------ get doctor slots data  ---
    takeLatest(slotActions.GET_SLOTS_REQUEST, getDoctorSlotsData),
    takeLatest(slotActions.GET_SLOTS_SILENTLY_REQUEST, getDoctorSlotsSilentlyData),

    // ------ create consultation  ---
    takeLatest(
      consultationActions.CREATE_CONSULTATION_REQUEST,
      createConsultation
    ),

    // ------ create Appointment  ---
    takeLatest(
      appointmentActions.CREATE_APPOINTMENT_REQUEST,
      createAppointment
    ),

    // ------ create patient history  ---
    takeLatest(
      patientActions.CREATE_PATIENT_HISTORY_REQUEST,
      createPatientHistoryDetails
    ),

    // ------ update patient history ---
    takeLatest(
      patientActions.UPDATE_PATIENT_HISTORY_REQUEST,
      updatePatientHistoryDetails
    ),

    // ------ create patient vitals ---
    takeLatest(patientActions.CREATE_VITALS_REQUEST, createVitals),

    // ------ update consultation data (examination) ---
    takeLatest(
      consultationActions.UPDATE_CONSULTATION_REQUEST,
      updateConsultation
    ),

    // ------ get patient tests ---
    takeLatest(patientActions.GET_PATIENT_TESTS_REQUEST, getPatientTests),

    // ------ submit patient tests ---
    takeLatest(
      patientActions.SUBMIT_PATIENT_TESTS_REQUEST,
      submitPatientTestsResponse
    ),

    takeLatest(patientActions.GET_LIFESTYLE_CHARTS_REQUEST, getLifestyleCharts),

    takeLatest(
      patientActions.GET_RECOMMENDED_DIET_PLAN_REQUEST,
      getRecommendedDietPlan
    ),

    takeLatest(
      patientActions.GET_RECOMMENDED_LIFESTYLE_REQUEST,
      getRecommendedLifestyle
    ),

    takeLatest(
      patientActions.CREATE_OR_UPDATE_RECOMMENDED_LIFESTYLE_REQUEST,
      createOrUpdateRecommendedLifestyle
    ),
    // ------ get treatment details of patient ---
    takeLatest(consultationActions.GET_TREATMENT_REQUEST, getTreatmentDetails),

    // ------ submit patient tests ---
    takeLatest(
      consultationActions.CREATE_UPDATE_TREATMENT_REQUEST,
      createUpdateTreatmentDetails
    ),

    // ------ consultation end ---
    takeLatest(consultationActions.END_CONSULTATION_REQUEST, endConsultation),

    // ------ create prescription ---
    takeLatest(
      prescriptionActions.CREATE_PRESCRIPTION_REQUEST,
      createPrescription
    ),

    // ------ get patient saved prescription ---
    takeLatest(
      prescriptionActions.GET_PATIENT_PRESCRIPTION_REQUEST,
      getPatientSavedPrescription
    ),

    takeLatest(patientActions.GET_EMOTION_CHARTS_REQUEST, getEmotionCharts),

    takeLatest(patientActions.GET_PHYSICAL_FITNESS_REQUEST, getPhysicalFitness),

    takeLatest(
      patientActions.GET_WEIGHT_GAIN_CHART_REQUEST,
      getWeightGainCharts
    ),

    takeLatest(patientActions.GET_VISITS_CHARTS_REQUEST, getVisitsCharts),

    takeLatest(hospitalAction.GET_RISKS_REQUEST, getRiskList),

    takeLatest(hospitalAction.GET_COMPLAINTS_REQUEST, getComplaintList),


    takeLatest(patientActions.GET_PATIENT_RISKS_REQUEST, getPatientRisks),

    takeLatest(patientActions.GET_PATIENT_COMPLAINTS_REQUEST, getPatientComplaints),

    takeLatest(patientActions.GET_PATIENT_ENDED_COMPLAINTS_REQUEST, getPatientComplaints),

    takeLatest(patientActions.GET_PATIENT_ENDED_RISKS_REQUEST, getPatientRisks),

    takeLatest(patientActions.CREATE_COMPLAINT_REQUEST, createPatientComplaint),

    takeLatest(patientActions.CREATE_RISK_REQUEST, createPatientRisk),

    takeLatest(patientActions.UPDATE_COMPLAINT_REQUEST, updatePatientComplaint),

    takeLatest(patientActions.UPDATE_RISK_REQUEST, updatePatientRisk),

    takeLatest(patientActions.UPDATE_PATIENT_DETAILS_REQUEST, updatePatientDetails),

    takeLatest(constantActionStatus.CREATE_CONSTANTS_REQUEST, createConstant),

    takeLatest(slotActions.GET_DATE_SLOTS_REQUEST, getDoctorSlotsDayWiseData),

    takeLatest(patientActions.ADD_WEIGHT_GAIN_CHART_DATA_REQUEST, addPatientWeightGain),

    takeLatest(patientActions.GET_PRESCRIPTION_CHART_REQUEST, getPrescriptionChart),

    takeLatest(patientActions.GET_DFMR_CHART_REQUEST, getDFMRChart),
    takeLatest(patientActions.GET_EMOTION_DATA_REQUEST, getEmotionData),
    takeLatest(consultationActions.UPDATE_PHYSICAL_DATA_REQUEST, createUpdatePhysicalData),
    takeLatest(action.SIGNOUT_REQUEST, authSignout),
    // ------ get provider details ---
    takeLatest(providerAction.GET_PROVIDER_DETAILS_REQUEST, getProviderDetails),

    takeLatest(providerAction.UPDATE_PROVIDER_DETAILS_REQUEST, updateProviderDetails),

    takeLatest(scheduleAction.GET_EVENTS_REQUEST, getDoctorScheduleEvents),
    takeLatest(scheduleAction.POST_EVENTS_REQUEST, createDoctorScheduleEvents),
    takeLatest(scheduleAction.UPDATE_EVENTS_REQUEST, updateScheduleEvent),
    takeLatest(scheduleAction.DELETE_EVENTS_REQUEST, deleteScheduleEvent),

    takeLatest(scheduleAction.GET_SLOT_SUMMARY_REQUEST, getDoctorSlotSummary),
    takeLatest(scheduleAction.UPDATE_SLOT_SUMMARY__REQUEST, updateSlotData),
    takeLatest(scheduleAction.BLOCK_SLOT_SUMMARY__REQUEST, blockDaySlot),
    takeLatest(scheduleAction.GET_UNAVAILABILITY_REQUEST, getUnavailabilityData),
    takeLatest(scheduleAction.POST_UNAVAILABILITY_REQUEST, postUnavailabilityData),

    takeLatest(scheduleAction.DELETE_UNAVAILABILITY_REQUEST, deleteUnavailabilityData),

    takeLatest(scheduleAction.GET_AVAILABILITY_REQUEST, getAvailabilityData),
    takeLatest(scheduleAction.POST_AVAILABILITY_REQUEST, postAvailabilityData),
    takeLatest(scheduleAction.UPDATE_AVAILABILITY_REQUEST, updateAvailabilityData),
    takeLatest(scheduleAction.MOVE_BULK_APPOINTEMNTS_REQUEST, moveBulkAppointments),
    takeLatest(scheduleAction.UNBLOCK_SLOT_SUMMARY_REQUEST, unblockDaySlot),
    takeLatest(scheduleAction.CANCEL_BULK_APPOINTMENTS_REQUEST, cancelBulkAppointment),
    takeLatest(scheduleAction.GET_TIMELINE_REQUEST, getDoctorTimeline),
    takeLatest(patientActions.CREATE_CONDITION_REQUEST, postConditionData),
    takeLatest(patientActions.GET_CONDITION_REQUEST, getComplaintWithConditionData),
    takeLatest(patientActions.GET_PATIENT_ASSESS_RISKS_REQUEST, getPatientRiskAsses),
    takeLatest(patientActions.GET_CONDITION_TIMELINE_REQUEST, getPatientTimeline),
  ]);
}
